import { render, staticRenderFns } from "./LoaLab2.vue?vue&type=template&id=08537034&"
import script from "./LoaLab2.vue?vue&type=script&lang=js&"
export * from "./LoaLab2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports